import Styles from './ShowcaseSection.module.css'

import {Showcase, type ShowcaseProps} from '../../generic/Showcase/Showcase'

export type ShowcaseSectionProps = ShowcaseProps

export const defaultProps: Partial<ShowcaseSectionProps> = {}

export const ShowcaseSection = (props: ShowcaseSectionProps) => {
  const initializedProps: ShowcaseSectionProps = {...defaultProps, ...props}

  return (
    <div className={Styles['ShowcaseSection']}>
      <Showcase {...initializedProps} />
    </div>
  )
}
